





























import Vue, { Component, PropType } from 'vue';
/** @ts-ignore: it cannot find the module because it doesn't use TS */
import VDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default Vue.extend({
  props: {
    id: String as PropType<string>,
    value: String as PropType<string>,
    state: Boolean as PropType<boolean | null>,
  },
  components: {
    VDatePicker: VDatePicker as Component,
  },
  computed: {
    day() {
      return this.value ? this.value.split('-')[2] : '';
    },
    month() {
      return this.value ? this.value.split('-')[1] : '';
    },
    year() {
      return this.value ? this.value.split('-')[0] : '';
    },
  },
  methods: {
    handleInput(value: string) {
      this.$emit('input', value);
    },
  },
  mounted() {
    const datePickerComponent = this.$refs.datePicker as Vue;
    const popupComponent = datePickerComponent.$refs.popup as any;
    popupComponent.displayPopupOld = popupComponent.displayPopup;
    popupComponent.displayPopup = function displayPopup() {
      this.displayPopupOld();
      this.left = `${parseInt(this.left, 10) - 150}px`;
    };
  },
});
